document.addEventListener('DOMContentLoaded', e => {
	const caseStudies = document.querySelectorAll('.case-studies')

	caseStudies.forEach(studies => {
		let degPerPx = 45 / window.innerHeight
		studies
			.querySelector('.star svg')
			.setAttribute(
				'style',
				`--rotate: ${degPerPx * studies.getBoundingClientRect().top * -1}deg`
			)

		window.addEventListener('scroll', () => {
			studies
				.querySelector('.star svg')
				.setAttribute(
					'style',
					`--rotate: ${degPerPx * studies.getBoundingClientRect().top * -1}deg`
				)
		})
	})
})
